import React from 'react';
export function Impressum() {
  return <div className="pt-32 pb-24 max-w-3xl mx-auto px-6 md:px-12 min-h-screen" data-id="element-241">
      <h1 className="text-4xl md:text-5xl font-serif text-accent mb-12" data-id="element-242">
        Impressum
      </h1>

      <div className="space-y-8 text-accent/80 font-light leading-relaxed" data-id="element-243">
        <div data-id="element-244">
          <h2 className="text-xl font-medium text-accent mb-4" data-id="element-245">
            Angaben gemäß § 5 DDG
          </h2>
          <p data-id="element-246">
            Josephine Henkel
            <br data-id="element-247" />
            Bastianstraße 10
            <br data-id="element-248" />
            13357 Berlin
            <br data-id="element-249" />
            Deutschland
          </p>
        </div>

        <div data-id="element-250">
          <h2 className="text-xl font-medium text-accent mb-4" data-id="element-251">Kontakt</h2>
          <p data-id="element-252">
            Telefon: +49 173 5227433
            <br data-id="element-253" />
            E-Mail: info@henkelenergie.de
          </p>
        </div>

        <div data-id="element-254">
          <h2 className="text-xl font-medium text-accent mb-4" data-id="element-255">Eintragungen</h2>
          <p data-id="element-256">
            BAFA Berater Nr. 236306
            <br data-id="element-257" />
            dena Energieberaternummer EB133137
          </p>
        </div>

        <div data-id="element-258">
          <h2 className="text-xl font-medium text-accent mb-4" data-id="element-259">
            Umsatzsteuer-ID
          </h2>
          <p data-id="element-260">DE327325844</p>
        </div>

        <div data-id="element-261">
          <h2 className="text-xl font-medium text-accent mb-4" data-id="element-262">
            Aufsichtsbehörde
          </h2>
          <p data-id="element-263">
            Baukammer Berlin
            <br data-id="element-264" />
            Heerstr. 18/20
            <br data-id="element-265" />
            14052 Berlin
            <br data-id="element-266" />
            Pflichtmitglied - Mitgliedsnummer P5025
          </p>
        </div>

        <div data-id="element-267">
          <h2 className="text-xl font-medium text-accent mb-4" data-id="element-268">
            Berufsbezeichnung und berufsrechtliche Regelungen
          </h2>
          <p data-id="element-269">
            Berufsbezeichnung: Architektin (M.Sc.), Ingenieurin und
            Energieeffizienz-Expertin
          </p>
        </div>

        <div data-id="element-270">
          <h2 className="text-xl font-medium text-accent mb-4" data-id="element-271">
            Berufshaftpflichtversicherung
          </h2>
          <p data-id="element-272">
            HDI-Versicherung AG
            <br data-id="element-273" />
            (Haftpflichtverband der Deutschen Industrie)
            <br data-id="element-274" />
            HDI-Platz 1<br data-id="element-275" />
            30659 Hannover
          </p>
        </div>

        <div data-id="element-276">
          <h2 className="text-xl font-medium text-accent mb-4" data-id="element-277">
            Verbraucherstreitbeilegung/Universalschlichtungsstelle
          </h2>
          <p data-id="element-278">
            Wir sind nicht bereit oder verpflichtet, an
            Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
            teilzunehmen.
          </p>
        </div>
      </div>
    </div>;
}